import { AuthUnauthenticatedError } from '@/teoCore/errors/AuthError';
import { TeoCore } from '@/teoCore/TeoCore';
import type { AnalysisConfiguration } from '@/teoCore/text/TeoText';
import { atom, useAtomValue } from '@/utils/jotai-svelte';
import { onMountWithActiveText, teoActiveTextAtom, TeoCore$ } from '@/utils/teo-context';

import { UserAtom$ } from '../auth/use-auth.svelte';

export const ConfigurationSetup$ = atom((get) => {
  const user = get(UserAtom$);
  if (!user.loggedIn) {
    return new AuthUnauthenticatedError();
  }
  return get(TeoCore$).getConfigOptions();
});

export function useConfigActions() {
  return {
    setConfig: (config: Partial<AnalysisConfiguration>) => {
      TeoCore.instance.activeText.configuration = config;
    },
  };
}

export const ActiveTextConfiguration$ = teoActiveTextAtom(
  (activeText) => activeText?.configuration ?? {},
);
ActiveTextConfiguration$.onMount = onMountWithActiveText(({ refresh }, activeText) => {
  refresh();
  return activeText.events.addEventListener('configChanged', refresh);
});

export const useConfigState = () => useAtomValue(ActiveTextConfiguration$);

export function useConfig() {
  return [useConfigState(), useConfigActions()] as const;
}

export const useConfigSetup = () => useAtomValue(ConfigurationSetup$);
